import { render, staticRenderFns } from "./miaoshu-wufenzu-fenleii.vue?vue&type=template&id=21c3a6e1&"
import script from "./miaoshu-wufenzu-fenleii.vue?vue&type=script&lang=ts&"
export * from "./miaoshu-wufenzu-fenleii.vue?vue&type=script&lang=ts&"
import style0 from "./miaoshu-wufenzu-fenleii.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports